export interface Experience {
  id: string;
  role: string;
  company: string;
  startDate: string;
  endDate: string | null;
  description: string;
  achievements: string[];
  techStack: string[];
}

export const experiences: Experience[] = [
  {
    id: "exp-1",
    role: "Senior Fullstack Developer",
    company: "Tech Company",
    startDate: "2024-01",
    endDate: null,
    description: "Leading development of scalable web applications and microservices architecture.",
    achievements: [
      "Architected and deployed microservices handling 10k+ requests/sec",
      "Mentored junior developers and established code review practices",
      "Reduced deployment time by 60% with CI/CD pipeline improvements",
    ],
    techStack: ["TypeScript", "React", "Node.js", "PostgreSQL", "Docker", "AWS"],
  },
  {
    id: "exp-2",
    role: "Fullstack Developer",
    company: "Software Studio",
    startDate: "2022-06",
    endDate: "2023-12",
    description: "Built and maintained client-facing web applications and internal tools.",
    achievements: [
      "Delivered 5+ production applications from concept to deployment",
      "Implemented real-time features using WebSockets",
      "Improved test coverage from 40% to 85%",
    ],
    techStack: ["React", "Python", "FastAPI", "MongoDB", "Redis"],
  },
  {
    id: "exp-3",
    role: "Backend Developer",
    company: "Data Corp",
    startDate: "2021-03",
    endDate: "2022-05",
    description: "Developed RESTful APIs and data processing pipelines for analytics platform.",
    achievements: [
      "Built ETL pipelines processing 1M+ records daily",
      "Designed and optimized database schemas for high-throughput workloads",
      "Integrated third-party APIs and payment systems",
    ],
    techStack: ["Python", "Django", "PostgreSQL", "Celery", "RabbitMQ"],
  },
  {
    id: "exp-4",
    role: "Junior Developer",
    company: "Startup Inc",
    startDate: "2020-01",
    endDate: "2021-02",
    description: "Full-stack development on an early-stage SaaS product.",
    achievements: [
      "Built core product features used by 500+ beta users",
      "Set up automated testing and deployment workflows",
      "Contributed to open-source libraries used in production",
    ],
    techStack: ["JavaScript", "Vue.js", "Express", "MySQL"],
  },
  {
    id: "exp-5",
    role: "Intern Software Engineer",
    company: "Tech Lab",
    startDate: "2019-06",
    endDate: "2019-12",
    description: "Contributed to internal tools and learned production software development practices.",
    achievements: [
      "Developed an internal dashboard that saved 10+ hours/week of manual work",
      "Learned agile development methodologies and Git workflows",
      "Presented technical demos to engineering team",
    ],
    techStack: ["HTML", "CSS", "JavaScript", "PHP", "MySQL"],
  },
];
